import React from 'react'

export default function Input(props) {
    return (
        <div className="user-page">
            <label htmlFor={props.htmlFor} className={props.cLable}>{props.name_label}</label>
            <input type={props.type} name={props.name} id={props.id} placeholder={props.place} value={props.value} onClick={props.onClick} onChange={props.onChange} />
            <small>{props.small}</small>
        </div>
    )
}
